var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.paginationOptions.Page,"page-sizes":_vm.pageSizes,"page-size":_vm.paginationOptions.PageSize,"layout":_vm.layout,"total":_vm.paginationOptions.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }